// TCRC Video Portal Translations
// Supports multiple languages for all user-facing text

export const SUPPORTED_LANGUAGES = {
  ENGLISH: 'en',
  SPANISH: 'es',
  ASL: 'asl',
  FILIPINO: 'tl',
  THAI: 'th',
  MANDARIN: 'zh',
  CANTONESE: 'zh-hk',
  HOKKIEN: 'zh-tw',
  KOREAN: 'ko',
  VIETNAMESE: 'vi',
  PUNJABI: 'pa',
  HMONG: 'hmn',
  HINDI: 'hi',
  ARABIC: 'ar',
  FARSI: 'fa',
  ARMENIAN: 'hy',
  RUSSIAN: 'ru',
  CAMBODIAN: 'km',
  JAPANESE: 'ja',
  KURDISH: 'ku',
  MIXTECO: 'mxt'
};

export const TRANSLATIONS = {
  [SUPPORTED_LANGUAGES.ENGLISH]: {
    // Header order CTA. Only English and Spanish define this key: the button is
    // shown only in those two languages, because the Order page itself is
    // limited to English and Spanish.
    orderComics: "Order Comics",

    // Welcome section
    welcomeTitle: "Welcome to the Video Portal",
    welcomeSubtitle: "Choose your language and what you'd like to see.",
    lantermanGreeting: "Lanterman and Friends creates fun, easy-to-understand videos about California's Regional Center system. Hundreds of short episodes show how the system supports people with intellectual and developmental disabilities. Families and professionals alike can discover inspiring stories that help everyone thrive.\n\nLet's Get Started!",
    chooseLanguage: "1. Choose your language",
    chooseVideos: "2. Choose your videos",
    
    // Video categories
    forPeopleReceivingServices: "For People Receiving Services",
    forServiceProviders: "For Service Providers",
    all: "All",
    
    // Featured section
    featuredTitle: "FEATURED: What are the California Regional Centers?",
    featuredDescription: "This video explains what California Regional Centers are and how they help people with developmental disabilities and their families access services and support.",
    
    // Jump to section
    jumpToVideo: "JUMP TO A VIDEO",
    allVideos: "ALL VIDEOS",
    goButton: "GO!",
    
    // Navigation
    home: "Home",
    about: "About",
    contact: "Contact",
    tcrcMainSite: "TCRC MAIN SITE",

    // Footer
    copyright: "© {year} Tri-Counties Regional Center",
    
    // Video content
    whatAreRegionalCenters: "What are the California Regional Centers?",
    learnMore: "Learn More →",
    
    // Series info
    episodes: "episodes",
    watchSeries: "Watch Series",
    
    // Contact page (from TRANSLATIONS-CONTACTUS.txt)
    contactUs: "Contact Us",
    californiaRegionalCenters: "California Regional Centers",
    californiaRegionalCentersDescription: "California has 21 regional centers with more than 40 offices located throughout the state.",
    clickHereToLearnMore: "Click here to learn more",
    findNearestRegionalCenter: "Or to find your nearest regional center,",
    clickHere: "click here",
    contactLantermanAndFriends: "Contact Lanterman and Friends",
    contactDescription: "For more information about Lanterman and Friends or this website, email us as follows:",
    email: "Email",
    emailPlaceholder: "email@example.com",
    subject: "Subject",
    selectSubject: "Select Subject",
    videoSuggestions: "Video Suggestions",
    websiteHelp: "Website Help & Support",
    generalFeedback: "General Feedback",
    message: "Message",
    messagePlaceholder: "Please describe your question or feedback...",
    sendMessage: "Send Message",
    
    // DDS Contact Panel
    contactHeading: "CONTACT",
    location: "Location", 
    mailingAddress: "Mailing Address",
    infoLabel: "Info:",
    emailLabel: "Email:",
    ttyLabel: "TTY:"
  },
  
  [SUPPORTED_LANGUAGES.SPANISH]: {
    // See the English block: this key exists only for English and Spanish.
    orderComics: "Solicitar C\u00F3mics",

    // Welcome section
    welcomeTitle: "Bienvenidos al portal de videos",
    welcomeSubtitle: "Elige tu idioma y lo que deseas ver.",
    lantermanGreeting: "Lanterman and Friends crean videos divertidos y fáciles de entender sobre el sistema de los Centros Regionales de California. Cientos de episodios cortos muestran cómo el sistema apoya a las personas con discapacidades intelectuales y del desarrollo. Tanto las familias como los profesionales pueden descubrir las herramientas y servicios que ayudan a todos a prosperar.\n\n¡Empecemos!",
    chooseLanguage: "1. Elige tu idioma",
    chooseVideos: "2. Elige tus videos",
    
    // Video categories
    forPeopleReceivingServices: "Para personas que reciben servicios",
    forServiceProviders: "Para proveedores de servicios",
    all: "Todos",
    
    // Featured section
    featuredTitle: "DESTACADO: ¿Qué son los Centros Regionales de California?",
    featuredDescription: "Este video explica qué son los Centros Regionales de California y cómo ayudan a las personas con discapacidades del desarrollo y a sus familias a acceder a servicios y apoyos.",
    
    // Jump to section
    jumpToVideo: "Ir a un video",
    allVideos: "Todos los videos",
    goButton: "¡IR!",
    
    // Navigation
    home: "Inicio",
    about: "Acerca de",
    contact: "Contacto",
    tcrcMainSite: "SITIO PRINCIPAL TCRC",

    // Footer
    copyright: "© {year} Centro Regional Tri-Condados",
    
    // Video content
    whatAreRegionalCenters: "¿Qué son los Centros Regionales de California?",
    learnMore: "Aprende más →",
    
    // Series info
    episodes: "episodios",
    watchSeries: "Ver serie",
    
    // Series titles
    hcbsFinalRule: "Regla Final de HCBS",
    individualProgramPlan: "Plan de Programa Individual (IPP)",
    emergencyPreparedness: "Preparación para emergencias",
    cyberSafety: "Seguridad cibernética",
    personCenteredThinking: "Pensamiento centrado en la persona (PCT)",
    boardOfDirectors: "La Junta directiva",
    
    // Contact page (from TRANSLATIONS-CONTACTUS.txt)
    contactUs: "Contáctanos",
    californiaRegionalCenters: "Centros Regionales de California",
    californiaRegionalCentersDescription: "California tiene 21 centros regionales con más de 40 oficinas ubicadas en todo el estado.",
    clickHereToLearnMore: "Haga clic aquí para obtener más información",
    findNearestRegionalCenter: "O para encontrar su centro regional más cercano,",
    clickHere: "haga clic aquí",
    contactLantermanAndFriends: "Contactar a Lanterman and Friends",
    contactDescription: "Para obtener más información sobre Lanterman and Friends o este sitio web, envíenos un correo electrónico de la siguiente manera:",
    email: "Correo electrónico",
    emailPlaceholder: "correo@ejemplo.com",
    subject: "Asunto",
    selectSubject: "Seleccionar asunto",
    videoSuggestions: "Sugerencias de video",
    websiteHelp: "Ayuda y soporte del sitio web",
    generalFeedback: "Comentarios generales",
    message: "Mensaje",
    messagePlaceholder: "Por favor describa su pregunta o comentario...",
    sendMessage: "Enviar mensaje",
    
    // DDS Contact Panel
    contactHeading: "CONTACTO",
    location: "Ubicación", 
    mailingAddress: "Dirección postal",
    infoLabel: "Información:",
    emailLabel: "Correo Electrónico:",
    ttyLabel: "TTY:"
  },
  
  [SUPPORTED_LANGUAGES.MANDARIN]: {
    // Welcome section
    welcomeTitle: "欢迎来到视频门户",
    welcomeSubtitle: "请选择您的语言和想观看的内容。",
    lantermanGreeting: "兰特曼和朋友制作了有趣且易于理解的视频，介绍加州的地区中心系统。数百个短片展示了该系统如何支持智力和发育障碍人士。家庭和专业人员都可以发现帮助每个人茁壮成长的工具和服务。\n\n让我们开始吧！",
    chooseLanguage: "1. 选择您的语言",
    chooseVideos: "2. 选择您的视频",
    
    // Video categories
    forPeopleReceivingServices: "为接受服务的人",
    forServiceProviders: "为服务提供者",
    all: "全部",
    
    // Featured section
    featuredTitle: "精选：加州地区中心是什么？",
    featuredDescription: "本视频介绍加州地区中心，以及它们如何帮助发育障碍人士及其家庭使用服务和支持。",
    
    // Jump to section
    jumpToVideo: "跳至视频",
    allVideos: "所有视频",
    goButton: "开始！",
    
    // Navigation
    home: "首页",
    about: "关于",
    contact: "联系",
    tcrcMainSite: "TCRC主站",
    
    // Footer
    copyright: "© {year} 三县地区中心",
    
    // Video content
    whatAreRegionalCenters: "加州地区中心是什么？",
    learnMore: "了解更多 →",
    
    // Series info
    episodes: "集数",
    watchSeries: "观看系列",
    
    // Series titles
    hcbsFinalRule: "HCBS 最终规则",
    individualProgramPlan: "个别化计划 (IPP)",
    emergencyPreparedness: "应急准备",
    cyberSafety: "网络安全",
    personCenteredThinking: "以人为本的思维（PCT）",
    boardOfDirectors: "董事会",
    
    // Contact page (from TRANSLATIONS-CONTACTUS.txt)
    contactUs: "联系我们",
    californiaRegionalCenters: "加州地区中心",
    californiaRegionalCentersDescription: "加州有21个地区中心，在全州各地有超过40个办公室。",
    clickHereToLearnMore: "请点击这里了解更多",
    findNearestRegionalCenter: "或要找到离您最近的地区中心，",
    clickHere: "请点击这里",
    contactLantermanAndFriends: "联系兰特曼和朋友",
    contactDescription: "有关兰特曼和朋友或本网站的更多信息，请通过以下方式给我们发电子邮件：",
    email: "电子邮件",
    emailPlaceholder: "邮箱@示例.com",
    subject: "主题",
    selectSubject: "选择主题",
    videoSuggestions: "视频建议",
    websiteHelp: "网站帮助与支持",
    generalFeedback: "一般反馈",
    message: "留言",
    messagePlaceholder: "请描述您的问题或意见...",
    sendMessage: "发送留言",
    
    // DDS Contact Panel
    contactHeading: "联系",
    location: "地点", 
    mailingAddress: "邮寄地址",
    infoLabel: "信息：",
    emailLabel: "电子邮件：",
    ttyLabel: "TTY："
  },
  [SUPPORTED_LANGUAGES.THAI]: {
    // Welcome section
    welcomeTitle: "ยินดีต้อนรับสู่พอร์ทัลวิดีโอ",
    welcomeSubtitle: "เลือกภาษาของคุณและสิ่งที่คุณต้องการรับชม",
    lantermanGreeting: "แลนเทอร์แมน และเพื่อน ๆ สร้างวิดีโอที่สนุกและเข้าใจง่ายเกี่ยวกับระบบศูนย์ประจำเขตของแคลิฟอร์เนีย วิดีโอสั้น ๆ หลายร้อยตอนแสดงให้เห็นว่าระบบนี้สนับสนุนผู้ที่มีความบกพร่องทางสติปัญญาและพัฒนาการอย่างไร ครอบครัวและผู้เชี่ยวชาญสามารถค้นพบบริการและเครื่องมือที่ช่วยให้ทุกคนเติบโตได้อย่างเต็มที่\n\nมาเริ่มกันเลย!",
    chooseLanguage: "1. เลือกภาษาของคุณ",
    chooseVideos: "2. เลือกวิดีโอของคุณ",
    
    // Video categories
    forPeopleReceivingServices: "สำหรับผู้รับบริการ",
    forServiceProviders: "สำหรับผู้ให้บริการ",
    all: "ทั้งหมด",
    
    // Featured section
    featuredTitle: "แนะนำ: อะไรคือศูนย์ประจำเขตของแคลิฟอร์เนีย?",
    featuredDescription: "วิดีโอนี้อธิบายว่าศูนย์ประจำเขตของแคลิฟอร์เนียคืออะไร และอธิบายวิธีเข้าถึงบริการและความช่วยเหลือสำหรับบุคคลที่มีความพิการทางพัฒนาการและครอบครัวของพวกเขา",
    
    // Jump to section
    jumpToVideo: "ไปยังวิดีโอ",
    allVideos: "วิดีโอทั้งหมด",
    goButton: "ไป!",
    
    // Navigation
    home: "หน้าแรก",
    about: "เกี่ยวกับ",
    contact: "ติดต่อ",
    tcrcMainSite: "เว็บไซต์หลัก TCRC",
    
    // Footer
    copyright: "© {year} ศูนย์ภูมิภาค Tri-Counties",
    
    // Video content
    whatAreRegionalCenters: "อะไรคือศูนย์ประจำเขตของแคลิฟอร์เนีย?",
    learnMore: "เรียนรู้เพิ่มเติม →",
    
    // Series info
    episodes: "ตอน",
    watchSeries: "ดูซีรีส์",
    
    // Series titles
    hcbsFinalRule: "กฎฉบับสมบูรณ์ของ HCBS",
    individualProgramPlan: "แผนโปรแกรมรายบุคคล (IPP)",
    emergencyPreparedness: "การเตรียมความพร้อมรับมือเหตุฉุกเฉิน",
    cyberSafety: "ความปลอดภัยทางไซเบอร์",
    personCenteredThinking: "แนวความคิดยึดบุคคลเป็นศูนย์กลาง (PCT)",
    boardOfDirectors: "คณะกรรมการบริหาร"
  },
  
  [SUPPORTED_LANGUAGES.HOKKIEN]: {
    // Welcome section
    welcomeTitle: "歡迎來到影片入口",
    welcomeSubtitle: "請選擇您的語言及想觀看的內容。",
    lantermanGreeting: "Lanterman 和朋友製作了有趣且易於理解的影片，介紹加州的地區中心系統。數百個短片展示了該系統如何支持智力及發展障礙人士。家庭和專業人員都可以發現幫助每個人茁壯成長的工具和服務。\n\n讓我們開始吧！",
    chooseLanguage: "1. 选择您的语言",
    chooseVideos: "2. 选择您的视频",
    
    // Video categories
    forPeopleReceivingServices: "为接受服务的人",
    forServiceProviders: "为服务提供者",
    all: "全部",
    
    // Featured section
    featuredTitle: "精選：加州地區中心是什麼？",
    featuredDescription: "本影片介紹加州地區中心，以及它們如何協助發展障礙人士及其家庭使用服務和支援。",
    
    // Jump to section
    jumpToVideo: "跳至影片",
    allVideos: "所有影片",
    goButton: "开始！",
    
    // Navigation
    home: "首頁",
    about: "關於",
    contact: "聯絡",
    tcrcMainSite: "TCRC主站",
    
    // Footer
    copyright: "© {year} 三縣地區中心",
    
    // Series info
    episodes: "集数",
    watchSeries: "观看系列",
    
    // Series titles
    hcbsFinalRule: "HCBS 最終規則",
    individualProgramPlan: "個別化計劃 (IPP)",
    emergencyPreparedness: "緊急準備",
    cyberSafety: "網路安全",
    personCenteredThinking: "以人為本的思維（PCT）",
    boardOfDirectors: "董事會",
    
    // Video content
    whatAreRegionalCenters: "加州地區中心是什麼？",
    learnMore: "了解更多 →"
  },
  
  [SUPPORTED_LANGUAGES.FILIPINO]: {
    // Welcome section
    welcomeTitle: "Maligayang pagdating sa Video Portal",
    welcomeSubtitle: "Pumili ng iyong wika at kung ano ang nais mong makita.",
    lantermanGreeting: "Gumagawa ang Lanterman at Friends ng mga masaya at madaling maunawaang video tungkol sa Regional Center system ng California. Daang-daang maiikling episodes ang nagpapakita kung paano sinusuportahan ng sistema ang mga taong may intellectual at developmental disabilities. Ang mga pamilya at mga propesyonal ay maaaring makadiskubre ng mga kasangkapan at serbisyong tumutulong sa lahat na umunlad.\n\nTara na't magsimula!",
    chooseLanguage: "1. Piliin ang iyong wika",
    chooseVideos: "2. Piliin ang iyong mga video",
    
    // Video categories
    forPeopleReceivingServices: "Para sa Mga Taong Tumatanggap ng Serbisyo",
    forServiceProviders: "Para sa Mga Tagapagbigay ng Serbisyo",
    all: "Lahat",
    
    // Featured section
    featuredTitle: "ITINAMPOK: Ano ang mga Regional Center ng California?",
    featuredDescription: "Ipinaliliwanag sa video na ito kung ano ang mga Regional Center ng California at kung paano sila tumutulong sa mga taong may developmental disabilities at sa kanilang pamilya upang makakuha ng serbisyo at suporta.",
    
    // Jump to section
    jumpToVideo: "Pumunta sa isang video",
    allVideos: "Lahat ng Video",
    goButton: "SIGE!",
    
    // Navigation
    home: "Tahanan",
    about: "Tungkol sa",
    contact: "Kontak",
    tcrcMainSite: "TCRC PANGUNAHING SITE",
    
    // Footer
    copyright: "© {year} Tri-Counties Regional Center. Lahat ng karapatan ay nakalaan.",
    
    // Video content
    whatAreRegionalCenters: "Ano ang mga Regional Center ng California?",
    learnMore: "Matuto Pa →",
    
    // Series info
    episodes: "episode",
    watchSeries: "Panoorin ang Serye",
    
    // Contact page (from TRANSLATIONS-CONTACTUS.txt)
    contactUs: "Makipag-ugnayan sa Amin",
    californiaRegionalCenters: "Mga Regional Center ng California",
    californiaRegionalCentersDescription: "Ang California ay may 21 regional center na may mahigit 40 opisina na matatagpuan sa buong estado.",
    clickHereToLearnMore: "Mag-click dito para matuto pa",
    findNearestRegionalCenter: "O upang mahanap ang pinakamalapit na regional center,",
    clickHere: "mag-click dito",
    contactLantermanAndFriends: "Makipag-ugnayan kay Lanterman and Friends",
    contactDescription: "Para sa higit pang impormasyon tungkol sa Lanterman and Friends o sa website na ito, mag-email sa amin tulad ng sumusunod:",
    email: "Koreo Elektroniko",
    emailPlaceholder: "koreo@halimbawa.com",
    subject: "Paksa",
    selectSubject: "Pumili ng Paksa",
    videoSuggestions: "Mga Mungkahi sa Video",
    websiteHelp: "Tulong at Suporta sa Website",
    generalFeedback: "Pangkalahatang Feedback",
    message: "Mensahe",
    messagePlaceholder: "Mangyaring ilarawan ang inyong tanong o feedback...",
    sendMessage: "Magpadala ng Mensahe",
    
    // DDS Contact Panel
    contactHeading: "KONTAK",
    location: "Lokasyon", 
    mailingAddress: "Address para sa Koreo",
    infoLabel: "Impormasyon:",
    emailLabel: "Koreo Elektroniko:",
    ttyLabel: "TTY:"
  },
  
  [SUPPORTED_LANGUAGES.ASL]: {
    // Welcome section
    welcomeTitle: "Welcome to the Video Portal",
    welcomeSubtitle: "Choose your language and what you'd like to see.",
    lantermanGreeting: "Lanterman and Friends creates fun, easy-to-understand videos about California's Regional Center system. Hundreds of short episodes show how the system supports people with intellectual and developmental disabilities. Families and professionals alike can discover inspiring stories that help everyone thrive.\n\nLet's Get Started!",
    chooseLanguage: "1. Choose your language",
    chooseVideos: "2. Choose your videos",
    
    // Video categories
    forPeopleReceivingServices: "For People Receiving Services",
    forServiceProviders: "For Service Providers", 
    all: "All",
    
    // Featured section
    featuredTitle: "FEATURED: What are the California Regional Centers?",
    featuredDescription: "This video explains what California Regional Centers are and how they help people with developmental disabilities and their families access services and support.",
    
    // Jump to section
    jumpToVideo: "JUMP TO A VIDEO",
    allVideos: "ALL VIDEOS", 
    goButton: "GO!",
    
    // Navigation
    home: "Home",
    about: "About",
    contact: "Contact",
    tcrcMainSite: "TCRC MAIN SITE",

    // Footer
    copyright: "© {year} Tri-Counties Regional Center",
    
    // Video content
    whatAreRegionalCenters: "What are the California Regional Centers?",
    learnMore: "Learn More →",
    
    // Series info
    episodes: "episodes",
    watchSeries: "Watch Series",
    
    // Contact page
    contactUs: "Contact Us",
    californiaRegionalCenters: "California Regional Centers",
    californiaRegionalCentersDescription: "California has 21 regional centers with more than 40 offices located throughout the state.",
    clickHereToLearnMore: "Click here to learn more",
    findNearestRegionalCenter: "Or to find your nearest regional center,",
    clickHere: "click here",
    contactLantermanAndFriends: "Contact Lanterman and Friends",
    contactDescription: "For more information about Lanterman and Friends or this website, email us as follows:",
    email: "Email",
    emailPlaceholder: "email@example.com",
    subject: "Subject",
    selectSubject: "Select Subject",
    videoSuggestions: "Video Suggestions",
    websiteHelp: "Website Help & Support",
    generalFeedback: "General Feedback",
    message: "Message",
    messagePlaceholder: "Please describe your question or feedback...",
    sendMessage: "Send Message",
    
    // DDS Contact Panel
    contactHeading: "CONTACT",
    location: "Location", 
    mailingAddress: "Mailing Address",
    infoLabel: "Info:",
    emailLabel: "Email:",
    ttyLabel: "TTY:"
  },
  
  [SUPPORTED_LANGUAGES.RUSSIAN]: {
    // Welcome section
    welcomeTitle: "Добро пожаловать в видеопортал",
    welcomeSubtitle: "Выберите язык и то, что хотите посмотреть.",
    lantermanGreeting: "Лантермэн и его друзья создают увлекательные и доступные видеоролики о системе региональных центров Калифорнии. Сотни коротких эпизодов демонстрируют, как система поддерживает людей с особенностями умственного и физического развития. Семьи и специалисты могут найти здесь инструменты и услуги, которые помогут каждому развиваться.\n\nДавайте начнем!",
    chooseLanguage: "Выберите ваш язык",
    chooseVideos: "Выберите видео",
    
    // Video categories
    forPeopleReceivingServices: "Для людей, получающих услуги",
    forServiceProviders: "Для предоставляющих услуги",
    all: "Все",
    
    // Featured section
    featuredTitle: "РЕКОМЕНДУЕМОЕ: Что такое Калифорнийские региональные центры?",
    featuredDescription: "Это видео объясняет, что такое Калифорнийские региональные центры и о том, как они помогают людям с особенностями развития и их семьям получать доступ к необходимым услугам и поддержке.",
    
    // Jump to section
    jumpToVideo: "Смотреть",
    allVideos: "ВСЕ ВИДЕО",
    goButton: "Смотреть",
    
    // Navigation
    home: "Главная",
    about: "О НАС",
    contact: "КОНТАКТ",
    tcrcMainSite: "ГЛАВНЫЙ САЙТ TCRC",
    
    // Footer
    copyright: "© {year} Региональный центр трех округов",
    
    // Video content
    whatAreRegionalCenters: "Что такое Калифорнийские Региональные Центры?",
    learnMore: "Узнать больше →",
    
    // Series info
    episodes: "эпизоды",
    watchSeries: "Смотреть серию",
    
    // Series titles
    hcbsFinalRule: "РЕГЛАМЕНТ HCBS",
    individualProgramPlan: "Индивидуальный Программный План (IPP)",
    emergencyPreparedness: "Готовность к чрезвычайным ситуациям",
    cyberSafety: "Кибербезопасность",
    personCenteredThinking: "Личностно-ориентированное мышление (PCT)",
    boardOfDirectors: "Совет директоров",
    
    // Contact page
    contactUs: "Связаться с нами",
    californiaRegionalCenters: "Региональные центры Калифорнии",
    californiaRegionalCentersDescription: "В Калифорнии насчитывается 21 региональных центров, имеющий более 40 офисов, расположенных по всему штату.",
    clickHereToLearnMore: "Нажмите сюда, чтобы узнать больше",
    findNearestRegionalCenter: "Или чтобы найти ближайший региональный центр,",
    clickHere: "нажмите сюда",
    seeAllRegionalCenters: "Чтобы просмотреть список всех региональных центров, нажмите сюда.",
    clickAnyRegionalCenter: "Нажмите на логотип ниже, чтобы перейти на сайт регионального центра",
    phoneLabel: "Телефон:",
    emailLabel: "Эл. почта:",
    ttyLabel: "TTY:"
  },

  [SUPPORTED_LANGUAGES.MIXTECO]: {
    // Welcome section - using Spanish translations (Mixteco is spoken, not written)
    welcomeTitle: "Bienvenido al portal de videos",
    welcomeSubtitle: "Elige tu idioma y qué te gustaría ver.",
    lantermanGreeting: "Lanterman y sus Amigos crean videos divertidos y fáciles de entender sobre el sistema de los Regional Centers de California. Cientos de episodios cortos muestran cómo el sistema apoya a las personas con discapacidades intelectuales y del desarrollo. Tanto las familias como los profesionales pueden descubrir las herramientas y servicios que ayudan a todos a prosperar.\n\n¡Empecemos!",
    chooseLanguage: "1. Elige tu idioma",
    chooseVideos: "2. Elige tus videos",
    
    // Video categories
    forPeopleReceivingServices: "Para personas que reciben servicios",
    forServiceProviders: "Para proveedores de servicios",
    all: "Todos los videos",
    
    // Featured section
    featuredTitle: "DESTACADO: ¿Qué son los Centros Regionales de California?",
    featuredDescription: "Este video explica qué son los Centros Regionales de California y cómo ayudan a las personas con discapacidades del desarrollo y sus familias a acceder a servicios y apoyo.",
    
    // Jump to section
    jumpToVideo: "IR A UN VIDEO",
    allVideos: "TODOS LOS VIDEOS",
    goButton: "¡IR!",
    
    // Navigation
    home: "Inicio",
    about: "Acerca de",
    contact: "Contacto",
    tcrcMainSite: "SITIO PRINCIPAL TCRC",

    // Video content
    whatAreRegionalCenters: "¿Qué son los Centros Regionales de California?",
    learnMore: "Aprende más →",
    
    // Series info
    episodes: "episodios",
    watchSeries: "Ver serie",
    
    // Contact page
    contactUs: "Contáctanos",
    californiaRegionalCenters: "Centros Regionales de California",
    californiaRegionalCentersDescription: "California tiene 21 centros regionales con más de 40 oficinas ubicadas en todo el estado.",
    clickHereToLearnMore: "Haz clic aquí para aprender más",
    findNearestRegionalCenter: "O para encontrar tu centro regional más cercano,",
    clickHere: "haz clic aquí",
    contactLantermanAndFriends: "Contacta a Lanterman y Amigos",
    contactDescription: "¡Nos encantaría saber de ti! Comparte tus ideas de videos, haz preguntas sobre el sitio web, o envíanos comentarios generales.",
    email: "Correo electrónico",
    emailPlaceholder: "tu.correo@ejemplo.com",
    subject: "Asunto",
    selectSubject: "Selecciona un asunto...",
    videoSuggestions: "Ideas y sugerencias de videos",
    websiteHelp: "Ayuda y preguntas del sitio web",
    generalFeedback: "Comentarios generales",
    message: "Mensaje",
    messagePlaceholder: "Dinos qué piensas...",
    sendMessage: "Enviar mensaje",
    contactHeading: "CONTACTO",
    location: "Ubicación",
    contact: "Contacto",
    mailingAddress: "Dirección postal",
    infoLabel: "Información:",
    emailLabel: "Correo electrónico:",
    ttyLabel: "TTY:"
    ,
    
    // Footer
    copyright: "© {year} Centro Regional Tri-Condados"
  },

  [SUPPORTED_LANGUAGES.CANTONESE]: {
    // Welcome section (from TRANSLATIONS-HOMEPAGE.txt)
    welcomeTitle: "歡迎來到影片入口",
    welcomeSubtitle: "請選擇您的語言及想觀看的內容。",
    lantermanGreeting: "Lanterman 和朋友製作了有趣且易於理解的影片，介紹加州的地區中心系統。數百個短片展示了該系統如何支持智力及發展障礙人士。家庭和專業人員都可以發現幫助每個人茁壯成長的工具和服務。\n\n讓我們開始吧！",
    chooseLanguage: "1. 揀選你的語言",
    chooseVideos: "2. 揀選你嘅影片",
    
    // Video categories
    forPeopleReceivingServices: "為接受服務的人",
    forServiceProviders: "為服務提供者",
    all: "全部",
    
    // Featured section
    featuredTitle: "精選：加州地區中心是什麼？",
    featuredDescription: "本影片介紹加州地區中心，以及它們如何協助發展障礙人士及其家庭使用服務和支援。",
    
    // Jump to section
    jumpToVideo: "跳至影片",
    allVideos: "所有影片",
    goButton: "開始！",
    
    // Navigation
    home: "首頁",
    about: "關於",
    contact: "聯絡",
    tcrcMainSite: "TCRC 主網站",
    
    // Footer
    copyright: "© {year} 三縣地區中心",
    
    // Video content
    whatAreRegionalCenters: "加州地區中心是什麼？",
    learnMore: "了解更多 →",
    
    // Series info
    episodes: "集數",
    watchSeries: "觀看系列",
    
    // Series titles
    hcbsFinalRule: "HCBS 最終規則",
    individualProgramPlan: "個別化計劃 (IPP)",
    emergencyPreparedness: "緊急準備",
    cyberSafety: "網路安全",
    personCenteredThinking: "以人為本的思維（PCT）",
    boardOfDirectors: "董事會"
  },

  [SUPPORTED_LANGUAGES.VIETNAMESE]: {
    // Welcome section
    welcomeTitle: "Chào mừng đến với Video Portal",
    welcomeSubtitle: "Chọn ngôn ngữ và nội dung bạn muốn xem.",
    lantermanGreeting: "Lanterman and Friends tạo ra những video vui nhộn, dễ hiểu về hệ thống của Trung tâm Vùng California. Hàng trăm tập phim ngắn này cho thấy hệ thống đã hỗ trợ tất cả những người khuyết tật như thế nào. Cả gia đình và các chuyên gia đều có thể tìm thấy những công cụ và dịch vụ giúp mọi người phát triển.\n\nHãy bắt đầu!",
    chooseLanguage: "1. Chọn ngôn ngữ của bạn",
    chooseVideos: "2. Chọn video của bạn",
    
    // Video categories
    forPeopleReceivingServices: "Cho Những Người Nhận Dịch Vụ",
    forServiceProviders: "Cho Các Nhà Cung Cấp Dịch Vụ",
    all: "Tất cả",
    
    // Featured section
    featuredTitle: "NỔI BẬT: Trung tâm Vùng California là gì?",
    featuredDescription: "Video này giải thích Trung tâm Vùng California là gì và cách họ giúp người khuyết tật và gia đình họ tiếp cận dịch vụ và hỗ trợ.",
    
    // Jump to section
    jumpToVideo: "Chuyển đến video",
    allVideos: "Tất cả Video",
    goButton: "ĐI!",
    
    // Navigation
    home: "Trang chủ",
    about: "Nội dung",
    contact: "Liên lạc",
    tcrcMainSite: "TRANG CHỦ TCRC",
    
    // Footer
    copyright: "© {year} Trung tâm Vùng Tri-Counties",
    
    // Video content
    whatAreRegionalCenters: "Trung tâm Vùng California là gì?",
    learnMore: "Tìm hiểu thêm →",
    
    // Series info
    episodes: "tập phim",
    watchSeries: "Xem Series",
    
    // Series Titles
    hcbsFinalRule: "Điều Lệ Cuối Cùng Của HCBS",
    individualProgramPlan: "Lịch Trình Cá Nhân (IPP)",
    emergencyPreparedness: "Chuẩn Bị Khi Khẩn Cấp",
    cyberSafety: "An Toan Mạng",
    personCenteredThinking: "Tư Duy Lấy Con Người Làm Trung Tâm (PCT)",
    boardOfDirectors: "Ban Giám Đốc",
    
    // Contact page
    contactUs: "Liên hệ với chúng tôi",
    californiaRegionalCenters: "Trung tâm Vùng California",
    californiaRegionalCentersDescription: "California có 21 trung tâm khu vực với hơn 40 văn phòng đặt khắp tiểu bang.",
    clickHereToLearnMore: "Nhấp vào đây để tìm hiểu thêm",
    findNearestRegionalCenter: "Hoặc để tìm trung tâm khu vực gần nhất của bạn,",
    clickHere: "nhấp vào đây",
    phoneLabel: "Điện thoại:",
    emailLabel: "Email:",
    ttyLabel: "TTY:"
  },

  [SUPPORTED_LANGUAGES.CAMBODIAN]: {
    // Welcome section (from TRANSLATIONS-HOMEPAGE.txt)
    welcomeTitle: "សូមស្វាគមន៍មកកាន់ប្រតាលវីដេអូ",
    welcomeSubtitle: "ជ្រើសរើសភាសារបស់អ្នក និងអ្វីដែលអ្នកចង់មើល។",
    lantermanGreeting: "Lanterman និងមិត្តភក្តិរបស់គាត់បង្កើតវីដេអូសប្បាយៗ ងាយយល់អំពីប្រព័ន្ធមជ្ឈមណ្ឌលតំបន់របស់កាលីហ្វ័រញ៉ា។ វីដេអូខ្លីរាប់រយបង្ហាញពីរបៀបដែលប្រព័ន្ធនេះគាំទ្រជនមានពិការភាពផ្លូវបញ្ញា និងអភិវឌ្ឍន៍។ គ្រួសារ និងអ្នកជំនាញអាចស្វែងរកឧបករណ៍ និងសេវាកម្មដែលជួយឱ្យមនុស្សគ្រប់គ្នាអភិវឌ្ឍ។\n\nតោះចាប់ផ្តើម!",
    chooseLanguage: "1. ជ្រើសរើសភាសារបស់អ្នក",
    chooseVideos: "2. ជ្រើសរើសវីដេអូរបស់អ្នក",
    
    // Video categories
    forPeopleReceivingServices: "សម្រាប់មនុស្សដែលទទួលសេវាកម្ម",
    forServiceProviders: "សម្រាប់អ្នកផ្តល់សេវាកម្ម",
    all: "ទាំងអស់",
    
    // Featured section
    featuredTitle: "សំខាន់: តើមជ្ឈមណ្ឌលតំបន់កាលីហ្វ័រញ៉ា គឺជាអ្វី?",
    featuredDescription: "វីដេអូនេះពន្យល់អំពីមជ្ឈមណ្ឌលតំបន់កាលីហ្វ័រញ៉ា និងរបៀបដែលពួកគេជួយមនុស្សមានពិការភាពអភិវឌ្ឍន៍ និងគ្រួសាររបស់ពួកគេក្នុងការចូលដំណើរការទៅសេវាកម្ម និងការគាំទ្រ។",
    
    // Jump to section
    jumpToVideo: "ចេញទៅទៅវីដេអូមួយ",
    allVideos: "វីដេអូទាំងអស់",
    goButton: "ទៅ!",
    
    // Navigation
    home: "ផ្ទះ",
    about: "អំពី",
    contact: "ទំនាក់ទំនង",
    tcrcMainSite: "គេហទំព័រ TCRC ចម្បង",
    
    // Footer
    copyright: "© {year} មជ្ឈមណ្ឌលតំបន់បីខាត",
    
    // Video content
    whatAreRegionalCenters: "តើមជ្ឈមណ្ឌលតំបន់កាលីហ្វ័រញ៉ាគឺជាអ្វី?",
    learnMore: "ស្វែងយល់​បន្ថែម →",
    
    // Series info
    episodes: "ភាគ",
    watchSeries: "មើលស៊េរី",
    
    // Series titles
    hcbsFinalRule: "បទបញ្ជាចុងក្រោយរបស់ HCBS",
    individualProgramPlan: "ផែនការកម្មវិធីបុគ្គល (IPP)",
    emergencyPreparedness: "ការត្រៀមសម្រាប់គ្រាអាសន្ន",
    cyberSafety: "សុវត្ថិភាព Cyber",
    personCenteredThinking: "ការគិតដោយផ្តោតទៅមនុស្ស",
    boardOfDirectors: "ក្រុមប្រឹក្សាភិបាល"
  },

  [SUPPORTED_LANGUAGES.ARABIC]: {
    // Welcome section
    welcomeTitle: "مرحبًا بكم في بوابة الفيديو",
    welcomeSubtitle: "اختر لغتك وما ترغب في مشاهدته",
    lantermanGreeting: "يُنشئ لانترمان وأصدقاؤه مقاطع فيديو ممتعة وسهلة الفهم حول نظام المركز الإقليمي في كاليفورنيا. تُوضح مئات الحلقات القصيرة كيف يدعم هذا النظام الاشخاص أصحاب الهمم. يمكن للعائلات والمتخصصين على حد سواء اكتشاف الأساليب والخدمات التي تساعد الجميع على الازدهار.\n\nهيا لنبدأ!",
    chooseLanguage: "1. اختر لغتك",
    chooseVideos: "2. اختر مقاطع الفيديو الخاصة بك",
    
    // Video categories
    forPeopleReceivingServices: "للأشخاص الذين يتلقون الخدمات",
    forServiceProviders: "لمقدمي الخدمات",
    all: "الكل",
    
    // Featured section
    featuredTitle: "مميز: ما هي المراكز الإقليمية في كاليفورنيا؟",
    featuredDescription: "يوضح هذا الفيديو المراكز الإقليمية في كاليفورنيا وكيف تساعد الاشخاص أصحاب الهمم وأسرهم للحصول على الخدمات والدعم.",
    
    // Jump to section
    jumpToVideo: "انتقل إلى الفيديو",
    allVideos: "جميع الفيديوهات",
    goButton: "اذهب!",
    
    // Navigation
    home: "الصفحة الرئيسية",
    about: "حول",
    contact: "للإتصال",
    tcrcMainSite: "الموقع الرئيسي لـ TCRC",
    
    // Footer
    copyright: "© {year} مركز المقاطعات الثلاث الإقليمي",
    
    // Video content
    whatAreRegionalCenters: "ماهى المراكز الإقليمية في كاليفورنيا؟",
    learnMore: "تعلم المزيد ←",
    
    // Series info
    episodes: "حلقات",
    watchSeries: "شاهد السلسلة",
    
    // Series titles
    hcbsFinalRule: "(HCBS) نظام الخدمات المنزلية والمجتمعية",
    individualProgramPlan: "(IPP) خطة البرنامج الفردية",
    emergencyPreparedness: "الاستعداد للطوارئ",
    cyberSafety: "السلامة الإلكترونية",
    personCenteredThinking: "(PCT) التفكير في مصلحة الفرد",
    boardOfDirectors: "مجلس الإدارة",
    
    // Contact page
    contactUs: "اتصل بنا",
    californiaRegionalCenters: "المراكز الإقليمية في كاليفورنيا",
    californiaRegionalCentersDescription: "لدى كاليفورنيا 21 مركزاً إقليمياً وتضم أكثر من 40 مكتب موزع في جميع أنحاء الولاية.",
    clickHereToLearnMore: "اضغط هنا لمعرفة المزيد",
    findNearestRegionalCenter: "أو للعثور على اقرب مركز إقليمي لك",
    clickHere: "اضغط هنا",
    phoneLabel: "الهاتف:",
    emailLabel: "البريد الإلكتروني:",
    ttyLabel: "TTY:"
  },

  [SUPPORTED_LANGUAGES.HINDI]: {
    // Welcome section
    welcomeTitle: "वीडियो पोर्टल में आपका स्वागत है",
    welcomeSubtitle: "अपनी भाषा और जो आप देखना चाहते हैं उसे चुनें।",
    lantermanGreeting: "Lanterman एंड फ़्रेंड्स कैलिफ़ोर्निया के Regional Center सिस्टम के बारे में मज़ेदार और आसानी से समझ में आने वाले वीडियो बनाते हैं। सैकड़ों छोटे एपिसोड दिखाते हैं कि यह सिस्टम बौद्धिक और विकासात्मक दिव्यांगता वाले लोगों का कैसे समर्थन करता है। परिवार और पेशेवर समान रूप से ऐसे उपकरण और सेवाएँ खोज सकते हैं जो सभी को आगे बढ़ने में मदद करें।\n\nचलिए शुरू करते हैं!",
    chooseLanguage: "1. अपनी भाषा चुनें",
    chooseVideos: "2. अपने वीडियो चुनें",
    
    // Video categories
    forPeopleReceivingServices: "सेवाएं प्राप्त करने वाले लोगों के लिए",
    forServiceProviders: "सेवा प्रदाताओं के लिए",
    all: "सभी",
    
    // Featured section
    featuredTitle: "विशेष: कैलिफ़ोर्निया रीजनल सेंटर्स क्या हैं?",
    featuredDescription: "यह वीडियो बताता है कि कैलिफ़ोर्निया रीजनल सेंटर्स क्या हैं और वे विकासात्मक दिव्यांगता वाले लोग और उनके परिवारों को सेवाएँ और सहयोग तक पहुँचने में कैसे मदद करते हैं।",
    
    // Jump to section
    jumpToVideo: "वीडियो पर जाएँ",
    allVideos: "सारे वीडियो",
    goButton: "जाएं!",
    
    // Navigation
    home: "होम",
    about: "जानकारी",
    contact: "संपर्क",
    tcrcMainSite: "TCRC मुख्य साइट",
    
    // Footer
    copyright: "© {year} ट्राई-काउंटीज़ रीजनल सेंटर",
    
    // Video content
    whatAreRegionalCenters: "कैलिफ़ोर्निया रीजनल सेंटर्स क्या हैं?",
    learnMore: "और जानें →",
    
    // Series info
    episodes: "एपिसोड",
    watchSeries: "श्रृंखला देखें",
    
    // Series titles
    hcbsFinalRule: "HCBS अंतिम नियम",
    individualProgramPlan: "व्यक्तिगत कार्यक्रम योजना (IPP)",
    emergencyPreparedness: "आपातकालीन स्तिथि तैयारी",
    cyberSafety: "साइबर सुरक्षा",
    personCenteredThinking: "व्यक्ति-केंद्रित सोच (PCT)",
    boardOfDirectors: "बोर्ड ऑफ़ डायरेक्टअर्स",
    
    // Contact page
    contactUs: "हमसे संपर्क करें",
    californiaRegionalCenters: "कैलिफ़ोर्निया क्षेत्रीय केंद्र",
    californiaRegionalCentersDescription: "कैलिफ़ोर्निया में 21 क्षेत्रीय केंद्र हैं, जिनके 40 से अधिक कार्यालय पूरे राज्य में स्थित हैं।",
    clickHereToLearnMore: "अधिक जानने के लिए यहाँ क्लिक करें",
    findNearestRegionalCenter: "या अपने सबसे नज़दीकी क्षेत्रीय केंद्र को खोजने के लिए,",
    clickHere: "यहाँ क्लिक करें",
    phoneLabel: "फ़ोन:",
    emailLabel: "ईमेल:",
    ttyLabel: "TTY:"
  },

  [SUPPORTED_LANGUAGES.JAPANESE]: {
    // Welcome section
    welcomeTitle: "ビデオポータルへようこそ",
    welcomeSubtitle: "言語と視聴したい内容を選んでください。",
    lantermanGreeting: "ランタンマンとその仲間たちは、カリフォルニア州地域交流センターシステムについて、楽しく分かりやすい動画を制作しています。知的障害や発達障害を持つ人々をどのように支援しているのか、たくさんあるショートエピソードを通して紹介しています。家族も専門家も、誰もが幸せに充実した生活を送るためのツールやサービスを見つけることができます。\n\nさぁ、始めましょう！",
    chooseLanguage: "1. 言語を選択",
    chooseVideos: "2. ビデオを選択",
    
    // Video categories
    forPeopleReceivingServices: "サービスを利用する方",
    forServiceProviders: "サービスを提供する側",
    all: "すべて",
    
    // Featured section
    featuredTitle: "注目: カリフォルニア州地域交流センターとは？",
    featuredDescription: "この動画では、カリフォルニア州地域交流センターとは何か、そして発達障害のある人々とその家族がサービスや支援を受ける方法について説明しています。",
    
    // Jump to section
    jumpToVideo: "動画を選択",
    allVideos: "全ての動画",
    goButton: "実行！",
    
    // Navigation
    home: "ホーム",
    about: "このサイトについて",
    contact: "お問い合わせ",
    tcrcMainSite: "TCRC メインサイト",
    
    // Footer
    copyright: "© {year} Tri-Counties Regional Center",
    
    // Video content
    whatAreRegionalCenters: "カリフォルニア州地域交流センターとは？",
    learnMore: "詳細を見る →",
    
    // Series info
    episodes: "エピソード",
    watchSeries: "シリーズを視聴",
    
    // Series titles
    hcbsFinalRule: "HCBS 最終規則",
    individualProgramPlan: "個別支援計画 (IPP)",
    emergencyPreparedness: "緊急事態の備え",
    cyberSafety: "サイバーセーフティ",
    personCenteredThinking: "本人を中心に考える (PCT)",
    boardOfDirectors: "取締役会",
    
    // Contact page
    contactUs: "お問い合わせ",
    californiaRegionalCenters: "カリフォルニア地域センター",
    californiaRegionalCentersDescription: "カリフォルニアには州全体に40以上のオフィスを持つ21の地域センターがあります。",
    clickHereToLearnMore: "詳細はこちらをクリック",
    findNearestRegionalCenter: "または最寄りの地域センターを見つけるには、",
    clickHere: "こちらをクリック",
    phoneLabel: "電話:",
    emailLabel: "メール:",
    ttyLabel: "TTY:"
  },

  [SUPPORTED_LANGUAGES.FARSI]: {
    // Welcome section
    welcomeTitle: "به درگاه ویدئو خوش آمدید",
    welcomeSubtitle: "زبان خود و آنچه می‌خواهید ببینید را انتخاب کنید.",
    lantermanGreeting: "لانترمن و دوستانش ویدئوهای سرگرم‌کننده و قابل‌فهمی درباره سیستم مراکز منطقه‌ای کالیفرنیا تولید می کند. صدها قسمت کوتاه نشان می‌دهد که این سیستم چگونه از افراد دارای ناتوانی‌های ذهنی و رشدی حمایت می‌کند. هم خانواده‌ها و هم متخصصان می‌توانند ابزارها و خدماتی را کشف کنند که به همه کمک می‌کند پیشرفت کنند.\n\nبیایید شروع کنیم!",
    chooseLanguage: "۱. زبان خود را انتخاب کنید",
    chooseVideos: "۲. ویدیوهای خود را انتخاب کنید",
    
    // Video categories
    forPeopleReceivingServices: "برای افرادی که خدمات دریافت می‌کنند",
    forServiceProviders: "برای ارائه‌دهندگان خدمات",
    all: "همه",
    
    // Featured section
    featuredTitle: "ویژه: مراکز منطقه‌ای کالیفرنیا چیست؟",
    featuredDescription: "این ویدئو توضیح می‌دهد مراکز منطقه‌ای کالیفرنیا چه هستند و چگونه به افراد دارای ناتوانی‌های رشدی و خانواده‌هایشان در دسترسی به خدمات و حمایت کمک می‌کنند.",
    
    // Jump to section
    jumpToVideo: "نشان‌ دادن ویدیو",
    allVideos: "همه ویدیوها",
    goButton: "برو!",
    
    // Navigation
    home: "خانه",
    about: "درباره",
    contact: "تماس",
    tcrcMainSite: "سایت اصلی TCRC",
    
    // Footer
    copyright: "© {year} مرکز منطقه‌ای سه شهرستان",
    
    // Video content
    whatAreRegionalCenters: "مراکز منطقه‌ای کالیفرنیا چه هستند؟",
    learnMore: "بیشتر بیاموزید ←",
    
    // Series info
    episodes: "قسمت‌ها",
    watchSeries: "تماشای مجموعه",
    
    // Series titles
    hcbsFinalRule: "آیین‌نامه نهایی اچ.‌سی. بی. اس",
    individualProgramPlan: "طرح برنامه فردی (آی.پی.پی)",
    emergencyPreparedness: "آمادگی در برابر شرایط اضطراری",
    cyberSafety: "امنیت سایبری",
    personCenteredThinking: "تفکر فرد-محور (پی.سی.تی)",
    boardOfDirectors: "هیئت مدیره",
    
    // Contact page
    contactUs: "تماس با ما",
    californiaRegionalCenters: "مراکز منطقه‌ای کالیفرنیا",
    californiaRegionalCentersDescription: "کالیفرنیا ۲۱ مرکز منطقه‌ای دارد با بیش از ۴۰ دفتر در سراسر ایالت.",
    clickHereToLearnMore: "برای کسب اطلاعات بیشتر اینجا کلیک کنید",
    findNearestRegionalCenter: "یا برای یافتن نزدیک‌ترین مرکز منطقه‌ای شما،",
    clickHere: "اینجا کلیک کنید",
    seeAllRegionalCenters: "برای دیدن لیست تمام مراکز منطقه‌ای اینجا کلیک کنید",
    clickAnyRegionalCenter: "روی هر کدام از لوگوهای مراکز منطقه‌ای در زیر کلیک کنید تا وارد وبسایتشان شوید.",
    phoneLabel: "تلفن:",
    emailLabel: "ایمیل:",
    ttyLabel: "TTY:"
  },

  [SUPPORTED_LANGUAGES.HMONG]: {
    // Welcome section
    welcomeTitle: "Zoo siab txais tos rau Video Portal",
    welcomeSubtitle: "Xaiv koj hom lus thiab yam koj xav pom.",
    lantermanGreeting: "Lanterman thiab nws cov phooj ywg tsim cov vis dis aus lom zem thiab nkag siab yooj yim hais txog California Regional Center. Pua pua zaj yeeb yaj kiab lus qhia txog txoj kev pab txhawb cov neeg muaj mob hlwb qeeb thiab loj hlob qeeb. Cov tsev neeg thiab cov txawj nste nrhiav tau kev qhia thiab kev pabcuam uas pab txhua tus vam meej.\n\nCia peb pib!",
    chooseLanguage: "1. Xaiv koj hom lus",
    chooseVideos: "2. Xaiv koj cov yeeb yaj kiab",
    
    // Video categories
    forPeopleReceivingServices: "Rau cov neeg tau txais kev pab",
    forServiceProviders: "Rau cov neeg muab kev pab",
    all: "Tag nrho",
    
    // Featured section
    featuredTitle: "UA NTEJ: California Regional Centers yog dab tsi?",
    featuredDescription: "Daim vis dis aus no piav txog California Regional Centers yuav los pab cov neeg muaj hlwb qeeb thiab lawv tsev neeg kom tau txais kev pabcuam thiab kev txhawb nqa li cas.",
    
    // Jump to section
    jumpToVideo: "Mus rau daim vis dis aus",
    allVideos: "Ntag Nhro Cov Vis Dis Aus",
    goButton: "MUS!",
    
    // Navigation
    home: "Hauv Paus",
    about: "Hais Txog",
    contact: "Tiv Toj",
    tcrcMainSite: "TCRC MAIN SITE",

    // Footer
    copyright: "© {year} Tri-Counties Regional Center",
    
    // Video content
    whatAreRegionalCenters: "California Regional Centers yog dab tsi?",
    learnMore: "Kawm ntxiv →",
    
    // Series info
    episodes: "ntu",
    watchSeries: "Saib Series",
    
    // Series titles
    hcbsFinalRule: "HCBS Kev Koo",
    individualProgramPlan: "Phiaj Xwm Kev Pabcuam Tus Kheej (IPP)",
    emergencyPreparedness: "Kev Npaj Ceev Xwm",
    cyberSafety: "Kev Nyab Xeeb Hauv Internet",
    personCenteredThinking: "Kev Xav Txog Tus Tswj Cuab Ua Ntej (PCT)",
    boardOfDirectors: "Pab Pawg Thawj Coj",
    
    // Contact page
    contactUs: "Tiv Toj Peb",
    californiaRegionalCenters: "California Regional Centers",
    californiaRegionalCentersDescription: "California muaj 21 lub chaw hauv cheeb tsam nrog ntau tshaj 40 lub chaw ua haujlwm nyob thoob plaws lub xeev.",
    clickHereToLearnMore: "Nyem qhov no kom paub ntau ntxiv",
    findNearestRegionalCenter: "Los yog nrhiav koj lub chaw hauv cheeb tsam ze tshaj plaws,",
    clickHere: "nyem qhov no",
    seeAllRegionalCenters: "Saib tag nrho cov Regional Centers",
    clickAnyRegionalCenter: "Nyem ib qho Regional Center logo hauv qab no mus saib lawv lub website",
    phoneLabel: "Xov tooj:",
    emailLabel: "Email:",
    ttyLabel: "TTY:"
  },

  [SUPPORTED_LANGUAGES.KOREAN]: {
    // Welcome section
    welcomeTitle: "비디오 포털에 오신 것을 환영합니다",
    welcomeSubtitle: "언어와 보고 싶은 영상을 선택하세요.",
    lantermanGreeting: "Lanterman과 친구들은 캘리포니아의 Regional Center 시스템에 대해 재미있고 이해하기 쉬운 영상을 만듭니다. 수백 개의 짧은 에피소드가 이 시스템이 지적 및 발달 장애가 있는 사람들을 어떻게 지원하는지 보여줍니다. 가족과 전문가 모두 각자가 성장하는 데 도움이 되는 도구와 서비스를 발견할 수 있습니다.\n\n시작해봅시다!",
    chooseLanguage: "1. 언어를 선택하세요",
    chooseVideos: "2. 비디오를 선택하세요",
    
    // Video categories
    forPeopleReceivingServices: "서비스를 받는 사람들을 위한",
    forServiceProviders: "서비스 제공자를 위한",
    all: "전체",
    
    // Featured section
    featuredTitle: "주요 영상: 캘리포니아 지역 센터란 무엇인가요?",
    featuredDescription: "이 영상은 캘리포니아 지역 센터가 무엇인지, 그리고 발달 장애인과 그 가족이 서비스와 지원을 받도록 어떻게 돕는지를 설명합니다.",
    
    // Jump to section
    jumpToVideo: "영상 건너뛰기",
    allVideos: "모든 영상",
    goButton: "시작!",
    
    // Navigation
    home: "홈",
    about: "정보", 
    contact: "연락처",
    tcrcMainSite: "TCRC 메인 사이트",
    
    // Footer
    copyright: "© {year} 트라이-카운티 지역 센터",
    
    // Video content
    whatAreRegionalCenters: "캘리포니아 지역 센터란 무엇인가?",
    learnMore: "자세히 보기 →",
    
    // Series info
    episodes: "에피소드",
    watchSeries: "시리즈 시청",
    
    // Series titles
    hcbsFinalRule: "HCBS 최종 규정",
    individualProgramPlan: "개인 프로그램 계획",
    emergencyPreparedness: "비상 대비",
    cyberSafety: "사이버 안전",
    personCenteredThinking: "사람 중심 사고",
    boardOfDirectors: "이사회",
    
    // Contact page
    contactUs: "문의하기",
    californiaRegionalCenters: "캘리포니아 지역 센터",
    seeAllRegionalCenters: "모든 Regional Centers 목록을 보려면 여기를 클릭하세요",
    clickAnyRegionalCenter: "아래의 아무 Regional Center 로고를 클릭하여 해당 웹사이트를 방문하세요"
  },

  [SUPPORTED_LANGUAGES.KURDISH]: {
    // Welcome section (from TRANSLATIONS-HOMEPAGE.txt)
    welcomeTitle: "Bi xêr hatin Porta Vîdeoyan",
    welcomeSubtitle: "Ziman û tiştên ku dixwazî bibînî hilbijêre.",
    lantermanGreeting: "Lanterman û hevalên wî vîdeoyên kêfxweş û hêsan-têgihiştinê li ser pergalê ya Navendên Herêmî ya Kalîforniyayê çêdikin. Bi sedan vîdyoyên kurt nîşan dide ka ev pergal çawa alîkariyê dike ji kesên ku xwedî astengiyên hiş û pêşkeftinê ne. Malbat û profesyonel dikarin amûr û xizmetên cûda bikar bibînin ku alîkarî dikin ku her kes pêş bikeve.\n\nWerin em dest pê bikin!",
    chooseLanguage: "1. Zimanê xwe hilbijêre",
    chooseVideos: "2. Vîdyoyên xwe hilbijêre",
    
    // Video categories
    forPeopleReceivingServices: "Ji bo kesên ku xizmetan distînin",
    forServiceProviders: "Ji bo pêşkeşkarên xizmetan",
    all: "Hemî",
    
    // Featured section
    featuredTitle: "Taybet: Navenda Herêmî yên Kalîforniyayê çi ne?",
    featuredDescription: "Ev vîdeo şîroveyê dike ku Navenda Herêmî yên Kalîforniyayê çi ne û ew çawa alîkarî dikin ji kesên ku xwedî astengên pêşkeftinê ne û malbatên wan da ku gihîjin xizmet û piştgirî.",
    
    // Jump to section
    jumpToVideo: "Nîşandana Vîdeo",
    allVideos: "Hemî Vîdeoyan",
    goButton: "HERE!",
    
    // Navigation
    home: "Mal",
    about: "Derbar",
    contact: "Têkilî",
    tcrcMainSite: "TCRC MAIN SITE",

    // Footer
    copyright: "© {year} Navenda Herêmî ya Sê Navçeyan",
    
    // Video content
    whatAreRegionalCenters: "Navenda Herêmî yên Kalîforniyayê çi ne?",
    learnMore: "Zêdetir fêr bibe →",
    
    // Series info
    episodes: "beşan",
    watchSeries: "Zincîrê bibîne",
    
    // Series titles
    hcbsFinalRule: "Rêbaza dawîya HCBS",
    individualProgramPlan: "Plana Bernameya Takekesî (IPP)",
    emergencyPreparedness: "Amadekarî jibo rewşa awarte",
    cyberSafety: "Ewlehîya Sîberî",
    personCenteredThinking: "Rêbaza Kes-navendî (PCT)",
    boardOfDirectors: "Lijneya Rêveberan",
    
    // Contact page (using English fallback for now - would need TRANSLATIONS-CONTACTUS.txt Kurdish section)
    contactUs: "Têkilî bi me re bigire",
    californiaRegionalCenters: "Navendên Herêmî ya Kalîforniyayê",
    californiaRegionalCentersDescription: "Di Kalîforniyayê de 21 navendên herêmî hene û li hemû îyaletê de ji 40 zêdetir ofîsan hene.",
    clickHereToLearnMore: "Ji bo zanyarîyên zêdetir li vir biklikîne",
    findNearestRegionalCenter: "An jî ji bo dîtina nêzîktirîn navenda herêmî,",
    clickHere: "li vir biklikîne",
    seeAllRegionalCenters: "Ji bo bibînî lista hemû Navendên Herêmî li vir biklikîne",
    clickAnyRegionalCenter: "Li ser her logo-yekî Navendên Herêmîyên li jêr biklikîne ji bo serdana malperê wan",
    phoneLabel: "Telefon:",
    emailLabel: "E-name:",
    ttyLabel: "TTY:"
  },
  
  [SUPPORTED_LANGUAGES.ARMENIAN]: {
    // Welcome section (from TRANSLATIONS-HOMEPAGE.txt)
    welcomeTitle: "Բարի գալուստ տեսապորտալ",
    welcomeSubtitle: "Ընտրեք ձեր լեզուն և այն, ինչ ցանկանում եք դիտել։",
    lantermanGreeting: "Լանթերմանը և իր ընկերները ներկայացնում են զվարճալի և հասանելի տեսանյութեր Կալիֆորնիայի տարածաշրջանային կենտրոնի համակարգի մասին։ Հարյուրավոր կարճ դրվագներ ցույց են տալիս, թե ինչպես է համակարգն աջակցում մտավոր և զարգացման խնդիրներ ունեցող մարդկանց։ Ընտանիքներն ու մասնագետները կարող են բացահայտել ոգեշնչող պատմություններ, որոնք կօգնեն բոլորին:\n\nԵկեք սկսե՜նք:",
    chooseLanguage: "Ընտրեք ձեր լեզուն",
    chooseVideos: "Ընտրեք ձեր տեսանյութը",
    
    // Video categories
    forPeopleReceivingServices: "Ծառայություններ ստացողների համար",
    forServiceProviders: "Ծառայութուններ մատուցողների համար",
    all: "Բոլորը",
    
    // Featured section
    featuredTitle: "ՏԵՍԱՆՅՈՒԹՈՒՄ՝ Ի՞նչ են Կալիֆորնիայի շրջանային կենտրոնները",
    featuredDescription: "Այս տեսանյութը պատմում է Կալիֆորնիայի շրջանային կենտրոնների մասին և թե ինչպես են դրանք օգնում ստանալ ծառայություններ և աջակցություն զարգացման խնդիրներ ունեցող անձանց և նրանց ընտանիքներին:",
    
    // Jump to section
    jumpToVideo: "Դիտել տեսանյութը",
    allVideos: "ԲՈԼՈՐ ՏԵՍԱՆՅՈՒԹԵՐԸ",
    goButton: "ԴԻՏԵ՜Լ",
    
    // Navigation
    home: "Գլխավոր",
    about: "ՄԵՐ ՄԱՍԻՆ",
    contact: "ԿԱՊ",
    tcrcMainSite: "TCRC ԳԼԽԱՎՈՐ ԿԱՅՔ",
    
    // Footer
    copyright: "© {year} Երեք Նահանգների Տարածաշրջանային Կենտրոն",
    
    // Video content
    whatAreRegionalCenters: "Ի՞նչ են Կալիֆորնիայի Շրջանային Կենտրոնները",
    learnMore: "Իմանալ ավելին →",
    
    // Series info
    episodes: "էպիզոդներ",
    watchSeries: "Դիտել շարքը",
    
    // Series titles
    hcbsFinalRule: "HCBS-Ի ՀԻՄՆԱՐԱՐ ԿԱՆՈՆԱԿԱՐԳ",
    individualProgramPlan: "Անհատական Ծրագրի Պլանավորում (IPP)",
    emergencyPreparedness: "Արտակարգ իրավիճակների պատրաստվածություն",
    cyberSafety: "Կիբերանվտանգություն",
    personCenteredThinking: "Անձնակենտրոն մտածողություն (PCT)",
    boardOfDirectors: "Տնօրենների խորհուրդ"
  },

  [SUPPORTED_LANGUAGES.PUNJABI]: {
    // Welcome section (from TRANSLATIONS-HOMEPAGE.txt)
    welcomeTitle: "ਵੀਡੀਓ ਪੋਰਟਲ ਵਿੱਚ ਤੁਹਾਡਾ ਸਵਾਗਤ ਹੈ",
    welcomeSubtitle: "ਆਪਣੀ ਭਾਸ਼ਾ ਅਤੇ ਜੋ ਤੁਸੀਂ ਦੇਖਣਾ ਚਾਹੁੰਦੇ ਹੋ, ਉਹ ਚੁਣੋ।",
    lantermanGreeting: "Lanterman and Friends ਕੈਲੀਫੋਰਨੀਆ ਦੇ ਰੀਜਨਲ ਸੈਂਟਰ ਸਿਸਟਮ ਬਾਰੇ ਮਜ਼ੇਦਾਰ, ਸਮਝਣ ਵਿੱਚ ਆਸਾਨ ਵੀਡੀਓ ਬਣਾਉਂਦੇ ਹਨ। ਸੈਂਕੜੇ ਛੋਟੇ ਐਪੀਸੋਡ ਦੱਸਦੇ ਹਨ ਕਿ ਕਿਵੇਂ ਇਹ ਸਿਸਟਮ ਬੌਧਿਕ ਅਤੇ ਵਿਕਾਸ ਸੰਬੰਧੀ ਅਸਮਰਥਤਾਵਾਂ ਵਾਲੇ ਲੋਕਾਂ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ। ਪਰਿਵਾਰ ਅਤੇ ਪੇਸ਼ੇਵਰ ਦੋਵੇਂ ਹੀ ਉਹ ਸਾਧਨ ਅਤੇ ਸੇਵਾਵਾਂ ਲੱਭ ਸਕਦੇ ਹਨ ਜੋ ਹਰ ਕਿਸੇ ਨੂੰ ਅੱਗੇ ਵਧਣ ਵਿੱਚ ਮਦਦ ਕਰਦੀਆਂ ਹਨ।",
    chooseLanguage: "1. ਆਪਣੀ ਭਾਸ਼ਾ ਚੁਣੋ",
    chooseVideos: "2. ਆਪਣੇ ਵੀਡੀਓ ਚੁਣੋ",
    
    // Video categories
    forPeopleReceivingServices: "ਸੇਵਾਵਾਂ ਪ੍ਰਾਪਤ ਕਰਨ ਵਾਲੇ ਲੋਕਾਂ ਲਈ",
    forServiceProviders: "ਸੇਵਾ ਪ੍ਰਦਾਤਾਵਾਂ ਲਈ",
    all: "ਸਭ",
    
    // Featured section
    featuredTitle: "ਵਿਸ਼ੇਸ਼: ਕੈਲੀਫੋਰਨੀਆ ਰੀਜਨਲ ਸੈਂਟਰ ਕੀ ਹਨ?",
    featuredDescription: "ਇਹ ਵੀਡੀਓ ਸਮਝਾਉਂਦੀ ਹੈ ਕਿ ਕੈਲੀਫੋਰਨੀਆ ਰੀਜਨਲ ਸੈਂਟਰ ਕੀ ਹਨ ਅਤੇ ਉਹ ਵਿਕਾਸਾਤਮਕ ਅਸਮਰੱਥਾਵਾਂ ਵਾਲੇ ਲੋਕਾਂ ਅਤੇ ਉਨ੍ਹਾਂ ਦੇ ਪਰਿਵਾਰਾਂ ਨੂੰ ਸੇਵਾਵਾਂ ਅਤੇ ਸਹਾਇਤਾ ਤੱਕ ਕਿਵੇਂ ਪਹੁੰਚ ਦਿੰਦੇ ਹਨ।",
    
    // Jump to section
    jumpToVideo: "ਵੀਡੀਓ 'ਤੇ ਜਾਓ",
    allVideos: "ਸਾਰੇ ਵੀਡੀਓ",
    goButton: "ਜਾਓ!",
    
    // Navigation
    home: "ਘਰ",
    about: "ਬਾਰੇ",
    contact: "ਸੰਪਰਕ",
    tcrcMainSite: "TCRC MAIN SITE",

    // Footer
    copyright: "© {year} ਟਰਾਈ-ਕਾਉਂਟੀਜ਼ ਰੀਜਨਲ ਸੈਂਟਰ",
    
    // Video content
    whatAreRegionalCenters: "ਕੈਲੀਫੋਰਨੀਆ ਦੇ Regional Centers ਕੀ ਹਨ?",
    learnMore: "ਹੋਰ ਜਾਣੋ →",
    
    // Series info
    episodes: "ਐਪੀਸੋਡ",
    watchSeries: "ਲੜੀ ਦੇਖੋ",
    
    // Contact page
    contactUs: "ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    californiaRegionalCenters: "ਕੈਲੀਫੋਰਨੀਆ ਰੀਜਨਲ ਸੈਂਟਰ",
    californiaRegionalCentersDescription: "ਕੈਲੀਫੋਰਨੀਆ ਵਿੱਚ 21 ਰੀਜਨਲ ਸੈਂਟਰ ਹਨ ਜਿਨ੍ਹਾਂ ਦੇ ਪੂਰੇ ਰਾਜ ਵਿੱਚ 40 ਤੋਂ ਵੱਧ ਦਫਤਰ ਸਥਿਤ ਹਨ।",
    clickHereToLearnMore: "ਹੋਰ ਜਾਣਨ ਲਈ ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ",
    findNearestRegionalCenter: "ਜਾਂ ਆਪਣਾ ਨਜ਼ਦੀਕੀ ਰੀਜਨਲ ਸੈਂਟਰ ਲੱਭਣ ਲਈ,"
  },
};

// Helper function to get translation with fallback
export const getTranslation = (language, key, fallback = '') => {
  const lang = language || SUPPORTED_LANGUAGES.ENGLISH;
  
  // Use direct logic to avoid circular import - Mixteco uses Spanish translations
  const translationLang = lang === SUPPORTED_LANGUAGES.MIXTECO ? SUPPORTED_LANGUAGES.SPANISH : lang;
  
  const translations = TRANSLATIONS[translationLang] || TRANSLATIONS[SUPPORTED_LANGUAGES.ENGLISH];
  return translations[key] || fallback;
};

// Helper function to format translations with variables
export const formatTranslation = (language, key, variables = {}) => {
  let translation = getTranslation(language, key);
  
  // Replace variables like {year} with actual values
  Object.keys(variables).forEach(variable => {
    translation = translation.replace(`{${variable}}`, variables[variable]);
  });
  
  return translation;
};

export default TRANSLATIONS;
